import React, { useCallback, useContext, useState } from 'react';
import { Box, Button, IconButton, makeStyles } from '@material-ui/core';
import { Delete as DeleteIcon, Edit as EditIcon, AddCircle, Add } from '@material-ui/icons';
import PropTypes from 'prop-types';
import { MeetingFuncsContext } from '../CreateEditMeetingsProvider';
import Subtitle2 from '../../common/typographys/Subtitle2';
import Body1 from '../../common/typographys/Body1';
import EntryBox from './EntryBox';
import DialogBeforeDayOrderItem from './DialogBeforeDayOrderItem';

const useStyles = makeStyles(() => ({
  itemHeader: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  actions: {
    display: 'flex',
  },
  addButton: {
    display: 'flex',
    justifyContent: 'flex-end',
    marginTop: '8px',
  },
}));

const BeforeDayOrderItems = ({ items }) => {
  const classes = useStyles();
  const { updateField } = useContext(MeetingFuncsContext);
  const [open, setOpen] = useState(false);
  const [editingItem, setEditingItem] = useState(null);

  const handleOpenAdd = useCallback(() => {
    setEditingItem(null);
    setOpen(true);
  }, []);

  const handleOpenEdit = useCallback(item => {
    setEditingItem(item);
    setOpen(true);
  }, []);

  const handleClose = useCallback(() => {
    setOpen(false);
    setEditingItem(null);
  }, []);

  const handleSave = useCallback(
    item => {
      if (editingItem) {
        updateField(
          'beforeDayOrderItems',
          items.map(x => (x.id === editingItem.id ? { ...x, ...item } : x))
        );
      } else {
        updateField('beforeDayOrderItems', [...items, { ...item, id: Date.now() }]);
      }
      handleClose();
    },
    [editingItem, items, updateField, handleClose]
  );

  const handleRemoveItem = useCallback(
    itemId => {
      updateField(
        'beforeDayOrderItems',
        items.filter(item => item.id !== itemId)
      );
    },
    [items, updateField]
  );

  return (
    <Box>
      {items.map(item => (
        <EntryBox key={item.id}>
          <Box className={classes.itemHeader}>
            <Box>
              <Subtitle2>{item.type_name}</Subtitle2>
              {item.title && <Body1>{item.title}</Body1>}
            </Box>
            <Box className={classes.actions}>
              <IconButton size="small" onClick={() => handleOpenEdit(item)}>
                <EditIcon />
              </IconButton>
              <IconButton size="small" onClick={() => handleRemoveItem(item.id)}>
                <DeleteIcon />
              </IconButton>
            </Box>
          </Box>
        </EntryBox>
      ))}
      {(!items || items.length === 0) && (
        <Body1 secondary>Não existem votos.</Body1>
      )}
      {/* <Box className={classes.addButton}>
        <IconButton onClick={handleOpenAdd}>
          <AddCircle />
        </IconButton>
      </Box> */}
      <Button
        startIcon={<Add />}
        variant="text"
        color="primary"
        size="small"
        onClick={handleOpenAdd}
        className={classes.addButton}
      >
        Adicionar Voto
      </Button>
      <DialogBeforeDayOrderItem
        open={open}
        item={editingItem}
        onClose={handleClose}
        onSave={handleSave}
      />
    </Box>
  );
};

BeforeDayOrderItems.defaultProps = {
  items: [],
};

BeforeDayOrderItems.propTypes = {
  items: PropTypes.array,
};

export default React.memo(BeforeDayOrderItems);
